<template>
  <div v-html="agreement" class="contentMargin">
  
  </div>
</template>
<style>
body{
  height:100%;
  padding: 0;
  margin:0;
}

</style>
<script>
import { httpget } from "../../api/interface";
export default {
  name: "contractIndex",
  directives: {},
  data() {
    return {
      agreement:""
    };
  },
  computed: {

  },
  activated() {
  },
  created() {
    let conid=this.$route.params.contractId;
    httpget("https://www.wkzq.com.cn/servlet/json?funcNo=905004&articleId="+conid,"").then(data => { 
      console.log(data.data)
      if(data.data.results && data.data.results.length>0){
        this.agreement=data.data.results[0].content;
        document.title=data.data.results[0].title;
      }
    });
  },
  updated() {},
  beforeDestroy() {},
  methods: {
  }
};
</script>
<style lang="less" >
.contentMargin{
  margin:5px 20px;

}
</style>
<style>
</style>